<template #content>
  <form>
    <ServiceProviderForm
      ref="mainForm"
      :populateWith="updatedData"
      :isMyTeam="true"
      @dirtyChanged="isFormDirty = $event"
      @validChanged="isFormValid = $event"
      @sendData="updateData"
    />
    <v-row
      align="center"
      justify="end"
      class="mr-1"
    >
      <v-btn
        :disabled="!isFormValid || !isFormDirty"
        type="submit"
        color="secondary"
        @click.prevent="onUpdateTeam"
      >
        {{ $t('forms.btn.save') }}
      </v-btn>
    </v-row>
  </form>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import ServiceProviderForm from '@/components/forms/ServiceProviderForm';
import { serialize } from 'object-to-formdata';
import FormPageMixin from '@/mixins/FormPageMixin';


export default {
    components: {
        ServiceProviderForm,
    },
    mixins: [
        FormPageMixin,
    ],
    computed: {
        ...mapGetters([
            'teamID',
            'hasPermission',
            'teamDateFormat',
        ]),
    },
    methods: {
        ...mapActions({
            disablePreventQuitFormular: 'disablePreventQuitFormular',
            reloadTeam: 'reloadTeam',
        }),
        async onUpdateTeam() {
            const payload = this.preparePayload(this.updatedData);
            await this.$rq.updateTeam(this.teamID, payload);
            this.$toasted.global.toast_success({
                message: this.$t('serviceProviders.updated', { name: this.updatedData.name }),
            });
            this.disablePreventQuitFormular();
            await this.reloadTeam(this.teamID);
        },
        preparePayload(payload) {
            const data = { ...this.$utils.removeEmptyNullOrUndefined(payload, true) };
            // for sending unset dateFormat through FormData format it should be empty string or nulls
            if (('dateFormat' in data) && !data.dateFormat) { data.dateFormat = null; }
            const { phoneNumber, ...res } = data;
            const options = { allowEmptyArrays: true };
            return payload.phoneNumber.number ? serialize(data, options) : serialize(res, options);
        },
    },
};
</script>
